import { Component, Input, OnChanges } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormComponent } from '../../../../../models/FormComponent';
import { Product } from '../../../../../models/Product';
import { ProductValidatorService, ValidationErrorSettings } from "../../../../../services/validators/product-validator.service";
import { ProductService } from '../../../../../services/product.service';

@Component({
  selector: 'app-ape-category',
  templateUrl: './ape-category.component.html',
  styleUrls: ['./ape-category.component.scss']
})
export class ApeCategoryComponent extends FormComponent implements OnChanges {
  @Input('product') product: Product; //assigned a COPY so that original is maintained to check diff.
  @ViewChild('formElement') formElement:ElementRef;
  @ViewChild('formData') formData:NgForm;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }
  categories: string[];

  constructor(
    private productService:ProductService,
    private _productValidator:ProductValidatorService
  ) { super() }

  ngOnInit(){
    let validationErrorSettings:ValidationErrorSettings = {fieldNameForMessage:'Category', required:true, minlength:4}
    this.initParent(this.product, this.formElement, this.formData, this._productValidator, validationErrorSettings);
  }

  ngOnChanges() {
    //ensure products have been loaded (and thus we can build a list of product categories)
    if(!this.product){
      return;
    }    
    //query product services for list of categories
    this.categories = this.productService.knownCategories();
  }


  //===================
  //User Interactions
  
  dropdownItemClicked($e){
    $e.preventDefault();  //don't follow link
    let categoryItem = $e.target.name;
    this.product.category = categoryItem;
    this.onFormChange(categoryItem);
  }


}




//=================
//Unused Code

  // onFormChange($e){
  //   let fieldId = '#'+this.formData.name;  //eg, 'apeSku'
  //   let fieldValue = $e as string;

  //   //Validate field value
  //   let fieldNameForMessage = 'Category', required=true, minlength=4;
  //   let result = this.productValidator.fieldValidator(fieldId, fieldValue, fieldNameForMessage, required, minlength);

  //   // Form errors, only show after initial blur
  //   let errorElementId = fieldId+'Error';
  //   if(this.formData.touched && result.success == false){
  //     $(errorElementId).html(result.message);
  //     $(errorElementId).show();
  //   } else {
  //     $(errorElementId).hide();
  //   }
  // }


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-category/ape-category.component.ts